<script>
  import { onMount } from 'svelte'
  export let content
  let staggerList
  onMount(() => {
    staggerList = gsap.utils.toArray(document.querySelectorAll('.col'))
    staggerList.forEach((e) => {
      gsap.from(e, {
        opacity: 0,
        y: -60,
        stagger: 0.2,
        scrollTrigger: {
          trigger: e,
          start: 'top bottom',
          toggleActions: 'play none none reverse',
        },
      })
    })
  })
</script>

<div>
  <ul>
    <li class="one col"><img src={content.images[0]} /></li>
    <li class="two col"><img src={content.images[1]} /></li>
    <li class="three col"><img src={content.images[2]} /></li>
    <li class="four col"><img src={content.images[3]} /></li>
    <li class="five col"><img src={content.images[4]} /></li>
  </ul>
  <p>Thin, ExtraLight, Light, Regular, Demi, Bold, ExtraBold, Heavy, Black</p>
</div>

<style lang="scss">
  @import '../../responsive.scss';
  p {
    font-family: 'Arteria-Regular';
    font-size: 4rem;
    color: var(--dark);
    margin-top: 40px;

    @include for-tablet {
      font-size: 3rem;
    }

    @include for-phone {
      font-size: 2.5rem;
    }
  }
  ul {
    display: grid;
    grid-template-columns: 2fr 1.1fr 2fr 5.3fr 1.2fr 2.6fr 8fr;

    @include for-tablet-p {
      grid-template-columns: 2fr 1fr 1.5fr 1fr 2fr 0.25fr;
      li {
        margin-bottom: 10px;
      }
    }
  }
  .one {
    grid-column: 1 / span 2;
    grid-row: 1;
  }
  .two {
    grid-row: 1;
    grid-column: 2 / span 2;
  }
  .three {
    grid-row: 1;
    grid-column: 4 / span 2;
    @include for-tablet-p {
      grid-row: 2;
      grid-column: 1 / span 4;
    }
  }
  .four {
    grid-row: 1;
    grid-column: 5 / span 2;
    @include for-tablet-p {
      grid-row: 2;
      grid-column: 4 / span 3;
    }
  }
  .five {
    grid-row: 1;
    grid-column: 7;
    @include for-tablet-p {
      grid-row: 3;
      grid-column: 1 / span 5;
    }
  }
</style>
